import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPuestoAsociado, getPuestos, removePuestosAsociados } from "../../../../../redux/actions/resolucion";
import ConfirmDialog from "../../../../commons/dialog/ConfirmDialog";
import PuestosAsociadosForm from "./PuestosAsociadosForm";
import PuestosAsociadosTable from "./PuestosAsociadosTable";

const initialValues = {
  sustanciasSeleccionadas: [],
  nombrePuesto: "",
  puesto: "",
  descripcionActividades: "",
  descripcionEstudios: "",
  informaRiesgos: false,
  poseeCapacitaciones: false,
  entregaProteccion: false,
  licenciasEspeciales: false,
  elementosDeProteccion: [],
  medidasPreventivas: [],
};

const PuestosAsociadosContainer = ({ handleCancelResolucion, nextForm }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.resolucion.postResolucion.puestos);
  const sustancias = useSelector((state) => state.resolucion.postResolucion.sustancias);
  const trabajadores = useSelector((state) => state.resolucion.postResolucion.trabajadores);
  const puestos = useSelector((state) => state.resolucion.puestos.data);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const [editingRow, setEditingRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [openDeletePuestosWarning, setOpenDeletePuestosWarning] = useState(false);
  const [puestosToDelete, setPuestosToDelete] = useState(null);

  useEffect(() => {
    dispatch(getPuestos(idDependenciaEmpleador));
  }, [])

  const handleOpenFormularioPuesto = (row) => {
    if (row) {
      // Editing: pass the row with sustanciasSeleccionadas pre-populated
      setEditingRow({
        ...row,
        sustanciasSeleccionadas: row.sustancias || [],
      });
    } else {
      setEditingRow(null);
    }
    setShowForm(true);
  };

  const handleDeletePuestos = () => {
    dispatch(removePuestosAsociados(puestosToDelete));
    setOpenDeletePuestosWarning(false);
  }

  const handleDelete = (rows) => {
    // Check if any trabajador has examenes tied to sustancias of these puestos
    const hasExamenes = trabajadores.some((t) =>
      rows.some((puesto) =>
        puesto.puesto === t.idPuesto &&
        puesto.sustancias?.some((sustId) => Object.hasOwn(t?.examenes, `${sustId}`))
      )
    );
    if (hasExamenes) {
      setPuestosToDelete(rows);
      setOpenDeletePuestosWarning(true);
    } else {
      dispatch(removePuestosAsociados(rows));
    }
  };

  const handleSubmit = (values) => {
    const { sustanciasSeleccionadas, ...sharedValues } = values;

    // Store as a single record with sustancias array
    dispatch(addPuestoAsociado({
      ...sharedValues,
      sustancias: sustanciasSeleccionadas,
    }, values?.index));

    setShowForm(false);
  };

  return (
    <div>
      {showForm ? (
        <PuestosAsociadosForm
          initialValues={editingRow || initialValues}
          onSubmit={handleSubmit}
          onCancel={() => setShowForm(false)}
          sustancias={sustancias}
          existingPuestos={data}
          editingIndex={editingRow?.index ?? null}
          puestos={puestos}
        />
      ) : (
        <PuestosAsociadosTable
          data={data}
          handleOpenFormularioPuesto={handleOpenFormularioPuesto}
          handleDelete={handleDelete}
          handleCancelResolucion={handleCancelResolucion}
          handleNext={() => nextForm('TrabajadoresSector')}
        />
      )}

      <ConfirmDialog
        open={openDeletePuestosWarning}
        handleClose={() => setOpenDeletePuestosWarning(false)}
        handleConfirm={handleDeletePuestos}
        title={"Eliminar Puestos"}
        warningText={"Algunos puestos tienen examenes asociados a sustancias ¿Seguro que desea eliminarlos?."}
      />
    </div>
  );
};

export default PuestosAsociadosContainer;
